import { APIService } from '@services/api/common-services';
import { UseMutateFunction, useMutation } from '@tanstack/react-query';
import { APICONFIG } from '@config/api.config';
import { IFccEnroll } from '.';

interface IFccEnrollData {
	mutate: UseMutateFunction<IFccEnroll, Error, IFccEnroll, unknown>;
	error: Error | null;
	isError: boolean;
	isPending: boolean;
}

export const useFccSlabMutation = (fccId: number | null | undefined): IFccEnrollData => {
	const createFccSlab = async (fccUserData: IFccEnroll): Promise<IFccEnroll> => {
		return await APIService.postData<IFccEnroll>(`${APICONFIG.FCC_ENROLL}`, fccUserData);
	};
	const updateFccSlab = async (fccUserData: IFccEnroll): Promise<IFccEnroll> => {
		return await APIService.patchData<IFccEnroll>(`${APICONFIG.FCC_ENROLL}${fccId}/`, fccUserData);
	};

	const { mutate, error, isError, isPending } = useMutation({
		mutationFn: fccId ? updateFccSlab : createFccSlab,
	});

	return {
		mutate,
		error,
		isError,
		isPending,
	};
};
